import * as React from 'react';
import { useApiClient, Products } from '@grandvisionhq/api-client';
import { useApiConfig } from '@grandvisionhq/state';

const useFetchBundle = (bundleSku)=>{
    const { productsUrl  } = useApiConfig();
    const params = React.useMemo(()=>bundleSku ? {
            sku: bundleSku
        } : null
    , [
        bundleSku
    ]);
    const bundleRequestOptions = React.useMemo(()=>({
            skip: !params
        })
    , [
        params
    ]);
    const [, data] = useApiClient(Products.getContactLensBundles, bundleRequestOptions, productsUrl, params);
    return data;
};

export { useFetchBundle };
//# sourceMappingURL=use-fetch-bundle.js.map
